import { useEffect } from 'react';
// @ts-expect-error File is untyped
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import enviro from 'enviro';
const QA_SURVEY_ID = 466;
const PROD_SURVEY_ID = 1210;
export const useFeedbackSurvey = () => {
  const {
    clientLoaded,
    loadSurvey
  } = useFeedbackLoader();
  useEffect(() => {
    if (clientLoaded) {
      loadSurvey(enviro.isProd() ? PROD_SURVEY_ID : QA_SURVEY_ID, 'CSAT');
    }
  }, [clientLoaded, loadSurvey]);
};
export default useFeedbackSurvey;